import api from '../api/axios';

export type ReadinessIssue = { level: 'error' | 'warning'; code: string; message: string; meta?: any };
export type VideoRenderOnReport = {
  runId: string;
  ready: boolean;
  issues: ReadinessIssue[];
  summary: string;
  counts: { sceneCount: number; ttsStepCount: number };
};

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (p: string) => `${BASE}${p}`;

export const getReportByRunId = async (runId: string) => {
  const res = await api.get(withBase(`/video-render-readiness/by-run/${runId}`));
  return res.data as VideoRenderOnReport;
};

const readinessService = { getReportByRunId };
export default readinessService;
